<script setup lang="ts">
const props = defineProps({
  selectedSub: {
    type: Object,
    required: true,
  },
  levelCatalog: {
    type: Number,
    required: true,
  },
});

const lastItem = computed(() => ({
  ...props.selectedSub,
  url: props.selectedSub.url,
  title: 'Показать все',
}));

const emit = defineEmits(['levelChange', 'clickCategories', 'search']);
</script>
<template>
  <div class="last-level">
    <MenuCatalogHeader
      :title="selectedSub.title"
      @close="emit('levelChange')"
      @search="emit('search')"
    />
    <div class="last-list">
      <MenuCatalogItem
        v-for="(block, index) in selectedSub.children"
        :key="index"
        :item="block"
        @click="emit('clickCategories', block)"
      />
      <MenuCatalogItem
        :item="lastItem"
        last
        @click="emit('clickCategories', lastItem)"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.last-level {
  width: 100vw;
  background: $white;
  height: calc((var(--fullvh, 100%)) - 50px - (var(--promobannerheight, 0px)));
  overflow-y: auto;
  @include xl-block {
    overflow-y: auto;
    height: calc(100vh - 96px);
  }

  .last-list {
    display: grid;
    padding: 0 12px;
  }
  .all {
    @include fz(14, 20, 400);
    position: relative;
    padding-right: 10px;
    padding: 12px 0;
  }
}
</style>
